// extracted by mini-css-extract-plugin
export var checkbox = "_2h-0";
export var circle = "_2h-3";
export var horizontalContainer = "_2h-7";
export var sm = "_2h-5";
export var switch0 = "_2h-2";
export var switchDisabled = "_2h-8";
export var switchEnabled = "_2h-1";
export var textSwitchContainer = "_2h-9";
export var textSwitchOption = "_2h-a";
export var textSwitchOptionSelected = "_2h-b";
export var verticalContainer = "_2h-6";
export var xs = "_2h-4";